import strings from 'strings';
import { CandidateEntity, ContactRole, HiringAuthorityEntity } from 'UI/constants/entityTypes';

export const COPIES = strings.searchProjects.forms.searchProject.sections;

export const CONTACT_TYPE_OPTIONS = [
  {
    id: String(ContactRole.Candidate),
    title: `${CandidateEntity.singular} Prospect`,
    value: String(ContactRole.Candidate)
  },
  {
    id: String(ContactRole.HiringAuthority),
    title: `${HiringAuthorityEntity.singular} Prospect`,
    value: String(ContactRole.HiringAuthority)
  }
];

export const CONTACT_TYPE_PAYLOAD_MAP = {
  [String(ContactRole.Candidate)]: {
    nameStatusId: ContactRole.Candidate
  },
  [String(ContactRole.HiringAuthority)]: {
    nameStatusId: ContactRole.HiringAuthority
  }
};

export const SKIP_EXISTING_CONTACTS_ID = 'skip';
export const ADD_TO_SEARCH_PROJECT_ID = 'add';

export const SKIP_DUPLICATES_OPTIONS = [
  {
    id: SKIP_EXISTING_CONTACTS_ID,
    title: COPIES.importOptions.fields.skipOption,
    value: SKIP_EXISTING_CONTACTS_ID
  },
  {
    id: ADD_TO_SEARCH_PROJECT_ID,
    title: COPIES.importOptions.fields.addToSearchProjectOption,
    value: ADD_TO_SEARCH_PROJECT_ID
  }
];

export const COMPANY_SKIP_DUPLICATES_OPTIONS = [
  {
    id: SKIP_EXISTING_CONTACTS_ID,
    title: COPIES.importOptions.fields.company.skipOption,
    value: SKIP_EXISTING_CONTACTS_ID
  },
  {
    id: ADD_TO_SEARCH_PROJECT_ID,
    title: COPIES.importOptions.fields.addToSearchProjectOption,
    value: ADD_TO_SEARCH_PROJECT_ID
  }
];

export const SKIP_DUPLICATES_PAYLOAD_MAP = {
  [SKIP_EXISTING_CONTACTS_ID]: {
    skipDuplicates: true
  },
  [ADD_TO_SEARCH_PROJECT_ID]: {
    skipDuplicates: false
  }
};
